export const spacing = 8;
export let container = 1600;
export const columns = 12;

export const breakPoints = {
    sm: {
        width: 820,
        spacing: 16
    },
    exlg: {
        width: 1600,
        spacing: 16
    }
    // md: {
    //     width: 1280,
    //     spacing: 16,
    // },
    // lg: {
    //     width: 1200,
    //     spacing: spacing * 2,
    // }
};

export const mainNewsBreakpoints = {
    sx: {
        width: 0,
        spacing: 16
    },
    sm: {
        width: 820,
        spacing: 16
    },
    md: {
        width: 1280,
        spacing: 16
    },
    exlg: {
        width: 1600,
        spacing: 16
    }
};
